import axios from "axios";
import { BASE_URL } from "./Url";

const api_interceptor = axios.create({
  baseURL: BASE_URL,
});

export { api_interceptor };
